import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Button, Col,  Form,  Input,  Row } from 'antd';
import { hideFileMappingWizardAddFieldModal, onFunctionFormDataChange, onFormulaReset, saveFixedField, editFixedField } from '../actions';
import { MARGIN_MD, MARGIN_SM, SPAN_HALF, MODAL_WIDTH_LG } from '../../../../../../styles/constants';
import { showFileMappingWizardPreviewRowList } from '../preview-row-list/actions';
import { sqlIsValid } from '../../../../../mapping-handler/dataset-builder/modals/components/utils';
import _ from "lodash";

const mapStateToProps = state => ({
  addFieldModalEditMode: state.scenes.dataManager.fileMapping.components.wizard.components.addField.addFieldModalEditMode,
  tempTableName: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
  FunctionFormData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.FunctionFormData,
});

const mapDispatchToProps = dispatch => ({
  onAddFieldModalHide: () => dispatch(hideFileMappingWizardAddFieldModal()),
  onFormulaReset: () => dispatch(onFormulaReset()),
  onPreview: () => dispatch(showFileMappingWizardPreviewRowList(true)),
  onChange: fields => dispatch(onFunctionFormDataChange(fields)),
  onSubmit: (tempTableName, functionData) => dispatch(saveFixedField(tempTableName, functionData)),
  onSubmitEdit: (tempTableName, functionData) => dispatch(editFixedField(tempTableName, functionData)),
});

const mapPropsToFields = ({FunctionFormData}) => ({
  nameValue: Form.createFormField({value: FunctionFormData !== null ? FunctionFormData.nameValue : null}),
  functionValue: Form.createFormField({value: FunctionFormData !== null ? FunctionFormData.functionValue : null})
})

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const FileMappingWizardFixedFormula = ({
                                      t,
                                      form,
                                      onAddFieldModalHide,
                                      onFormulaReset,
                                      FunctionFormData,
                                      tempTableName,
                                      onPreview,
                                      onSubmit,
                                      onSubmitEdit,
                                      addFieldModalEditMode,
                                    }) => {

  return (
    <Fragment>
          <div>
            <Row type='flex' style={{marginTop: MARGIN_MD}}>
              <Col style={{width: MODAL_WIDTH_LG}}>
                  <Form className="advanced-form">
                    <Row type='flex' justify="space-between">
                      <Col span={SPAN_HALF}>
                        <Form.Item
                          className="form-item"
                          label={t('data.fileMapping.addField.value.label')}
                          >
                          {form.getFieldDecorator('functionValue')(
                            <Input 
                              title={form.getFieldValue('functionValue')}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    <Col span={SPAN_HALF}>
                      <Row type='flex' justify="space-between">
                        <Col>
                          <Row type='flex' justify="start">
                            <Button
                              onClick ={async () => {
                                if (!sqlIsValid(FunctionFormData.functionValue, t)) return;
                                onPreview();
                              }}
                              icon="table"
                              disabled={FunctionFormData.nameValue === '' || FunctionFormData.functionValue === null || FunctionFormData.functionValue === ''}
                              style={{ marginLeft: MARGIN_SM}}>
                              {t('data.fileMapping.addField.preview.label')}
                            </Button>
                            <Button
                              onClick={onFormulaReset}
                              icon="delete"
                              style={{ marginLeft: MARGIN_SM}}>
                              {t('data.fileMapping.addField.reset.label')}
                            </Button>
                          </Row>
                        </Col>
                        <div>
                          <Button 
                            onClick={onAddFieldModalHide}
                            style={{marginRight: MARGIN_SM}}
                          >
                            {t('commons.buttons.close.title')}
                          </Button>
                          {(addFieldModalEditMode === false ) && (
                            <Button
                              onClick ={async () => {
                                if (!sqlIsValid(FunctionFormData.functionValue, t)) return;
                                onSubmit(tempTableName, FunctionFormData);
                              }}
                              type="primary"
                              disabled={FunctionFormData.nameValue === '' || FunctionFormData.functionValue === null || FunctionFormData.functionValue === ''}
                              >
                              {t('commons.buttons.confirm.title')}
                            </Button>
                          )}
                          {(addFieldModalEditMode === true ) && (
                            <Button
                              onClick ={async () => {
                                if (!sqlIsValid(FunctionFormData.functionValue, t)) return;
                                onSubmitEdit(tempTableName, FunctionFormData);
                              }}
                              type="primary"
                              disabled={FunctionFormData.nameValue === '' || FunctionFormData.functionValue === null || FunctionFormData.functionValue === ''}
                              >
                              {t('commons.buttons.confirm.title')}
                            </Button>
                          )}
                        </div>
                      </Row>
                    </Col>
                    </Row>
                  </Form>
              </Col>
            </Row>
          </div>
    </Fragment>
);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
  )(FileMappingWizardFixedFormula);